import { styled } from 'styled-components'

export const NotificationWrapper = styled.div`
  align-items: center;
  justify-content: flex-start;
  height: 70px;
  border-radius: 5px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  width: 100%;
  max-width: 443px;
  flex-direction: row;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-bottom: ${({ $type, theme }) => {
    if ($type === 'success') {
      return `4px solid ${theme.colors.success50}`
    }
    if ($type === 'error') {
      return `4px solid ${theme.colors.error50}`
    }
    if ($type === 'info') {
      return `4px solid ${theme.colors.info50}`
    }
    return 'none'
  }};
`
